import React from 'react';
import {
  Stack,
  Tooltip,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { AlertInfoIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';
import { Grid } from '@fortress-technology-solutions/fortress-component-library/Molecules';

type Building = {
  id: string,
  buildingName: string,
  isCompliant: boolean,
  applicableFraction: string,
  currentFraction: string,
  totalUnits: number,
  totalNonCompliantUnits: number,
};

type Props = {
  building: Building,
};

const InformationItem = ({ title, value, tooltipText }) => (
  <Stack direction="column">
    <Stack direction="row" spacing={0.5}>
      <Typography variant="labelMedium">{title}:</Typography>
      <Tooltip title={tooltipText}>
        <AlertInfoIcon
          sx={{
            fontSize: 15,
            color: 'text.secondary',
          }}
        />
      </Tooltip>
    </Stack>
    <Typography
      variant="labelMedium"
      sx={{
        color: 'text.secondary',
      }}
    >
      {value}
    </Typography>
  </Stack>
);

function BuildingNavigationCard({ building }: Props) {
  return (
    <Stack direction="column" spacing={1} sx={{ maxWidth: 250 }}>
      <Grid container spacing={0.5} rowSpacing={1}>
        <Grid item xs={6}>
          <InformationItem
            title="Current"
            value={building.currentFraction}
            tooltipText="The current applicable fraction based on active NAUR events."
          />
        </Grid>
        <Grid item xs={6}>
          <InformationItem
            title="Required"
            value={building.applicableFraction}
            tooltipText="The Next Available Unit Rule uses the lesser of the Unit and Floor Space Applicable Fractions."
          />
        </Grid>
        <Grid item xs={6}>
          <InformationItem
            title="Total Units"
            value={building.totalUnits}
            tooltipText="The number of all residential units within this building, regardless of status and type."
          />
        </Grid>
        <Grid item xs={6}>
          <InformationItem
            title="Non-Compl Units"
            value={building.totalNonCompliantUnits}
            tooltipText="The number of residential units in the building
          that are considered non-compliant under the Next Available Unit Rule."
          />
        </Grid>
      </Grid>
    </Stack>
  );
}

export default BuildingNavigationCard;
